const SAFETY_BUFFER_MINUTES = 5;

type AutomatchingDelayValidationArgs = {
  delayMinutes?: number | null;
  firstShiftStart?: Date | number | null;
  nowMs?: number;
  safetyBufferMinutes?: number;
};

export const isAutomatchingDelayTooLong = ({
  delayMinutes,
  firstShiftStart,
  nowMs = Date.now(),
  safetyBufferMinutes = SAFETY_BUFFER_MINUTES,
}: AutomatchingDelayValidationArgs): boolean => {
  if (!delayMinutes || !firstShiftStart) {
    return false;
  }

  const firstShiftStartMs =
    firstShiftStart instanceof Date
      ? firstShiftStart.getTime()
      : firstShiftStart;

  const minutesUntilFirstShiftStart = Math.floor(
    (firstShiftStartMs - nowMs) / 60000,
  );
  const maxDelayMinutes = minutesUntilFirstShiftStart - safetyBufferMinutes;

  return delayMinutes > maxDelayMinutes;
};

